





































import { Vue, Component, Prop } from 'vue-property-decorator'
import { FileInfo, PathController, VFS } from '@/api/types'
import { PageConfig } from '@/store/modules/PageConfigs'
import * as fileIcon from '@/assets/file-icon.png'

import Loader from '@/components/Loader.vue'
import filepath from '@/api/filepath'

interface FileInfoWithThumbnail extends FileInfo {
  Thumbnails?: string[];
  ChildCount?: number;
}

@Component({
  components: { Loader }
})
export default class InfoPoint extends Vue {
  @Prop() files!: FileInfo[]
  @Prop() root!: FileInfo
  @Prop() vfs!: Promise<VFS>
  @Prop() pageConfig!: PageConfig
  @Prop() pathController!: PathController

  private filesWithThumbnail: FileInfo[] = []
  private isReady = false

  async mounted () {
    this.filesWithThumbnail = await Promise.all(this.files.map(async (f: FileInfo) => {
      const vfs = await this.vfs
      const thumbnails: string[] = []
      const path = this.pathController.resolve(f).path
      let children = await vfs.ReadDir(path)
      children = children.filter((f: FileInfo) => !f.IsDir)
      for (const f in children) {
        if (!children[f].IsDir) {
          const filename = await vfs.ResolveFilename(filepath.join(path, children[f].Name))
          if (children[f].ContentType === 'video/mp4' || children[f].ContentType === 'image/png' || children[f].ContentType === 'image/jpeg' || children[f].ContentType === 'application/pdf') {
            thumbnails.push(`${filename}.thumbnail`)
          } else {
            thumbnails.push(String(fileIcon))
          }
        }
      }
      return {
        ...f,
        Thumbnails: thumbnails,
        ChildCount: children.length
      }
    }))

    const scroll = this.$refs.scroller as HTMLElement
    if (scroll) {
      scroll.scrollTop = this.pageConfig.scrollPosition
      scroll.addEventListener('scroll', this.handleScroll)
    }
    this.isReady = true
  }

  handleScroll (event: any) {
    this.$emit('on-scroll', event.target.scrollTop)
  }
}

